"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeMap = exports.iconMap = void 0;
var react_1 = __importStar(require("react"));
var theme_1 = require("../theme");
var react_jss_1 = require("react-jss");
var react_svg_1 = require("react-svg");
var classnames_1 = __importDefault(require("classnames"));
var ai_svg_1 = __importDefault(require("./icons/ai.svg"));
var archive_svg_1 = __importDefault(require("./icons/archive.svg"));
var arrowForward_svg_1 = __importDefault(require("./icons/arrowForward.svg"));
var arrowBack_svg_1 = __importDefault(require("./icons/arrowBack.svg"));
var arrowOpen_svg_1 = __importDefault(require("./icons/arrowOpen.svg"));
var arrowClose_svg_1 = __importDefault(require("./icons/arrowClose.svg"));
var arrowUp_svg_1 = __importDefault(require("./icons/arrowUp.svg"));
var arrowDown_svg_1 = __importDefault(require("./icons/arrowDown.svg"));
var attachedFile_svg_1 = __importDefault(require("./icons/attachedFile.svg"));
var badge_svg_1 = __importDefault(require("./icons/badge.svg"));
var block_svg_1 = __importDefault(require("./icons/block.svg"));
var calendarEmpty_svg_1 = __importDefault(require("./icons/calendarEmpty.svg"));
var calendarFull_svg_1 = __importDefault(require("./icons/calendarFull.svg"));
var card_svg_1 = __importDefault(require("./icons/card.svg"));
var cardAdd_svg_1 = __importDefault(require("./icons/cardAdd.svg"));
var clock_svg_1 = __importDefault(require("./icons/clock.svg"));
var code_svg_1 = __importDefault(require("./icons/code.svg"));
var comment_svg_1 = __importDefault(require("./icons/comment.svg"));
var copy_svg_1 = __importDefault(require("./icons/copy.svg"));
var dashboard_svg_1 = __importDefault(require("./icons/dashboard.svg"));
var delete_svg_1 = __importDefault(require("./icons/delete.svg"));
var details_svg_1 = __importDefault(require("./icons/details.svg"));
var download_svg_1 = __importDefault(require("./icons/download.svg"));
var drafts_svg_1 = __importDefault(require("./icons/drafts.svg"));
var edit_svg_1 = __importDefault(require("./icons/edit.svg"));
var experienceAward_svg_1 = __importDefault(require("./icons/experienceAward.svg"));
var experienceEducation_svg_1 = __importDefault(require("./icons/experienceEducation.svg"));
var faq_svg_1 = __importDefault(require("./icons/faq.svg"));
var favoriteAdd_svg_1 = __importDefault(require("./icons/favoriteAdd.svg"));
var favoriteRemove_svg_1 = __importDefault(require("./icons/favoriteRemove.svg"));
var filter_svg_1 = __importDefault(require("./icons/filter.svg"));
var fingerprint_svg_1 = __importDefault(require("./icons/fingerprint.svg"));
var graph_svg_1 = __importDefault(require("./icons/graph.svg"));
var heart_svg_1 = __importDefault(require("./icons/heart.svg"));
var image_svg_1 = __importDefault(require("./icons/image.svg"));
var inbox_svg_1 = __importDefault(require("./icons/inbox.svg"));
var key_svg_1 = __importDefault(require("./icons/key.svg"));
var link_svg_1 = __importDefault(require("./icons/link.svg"));
var list_svg_1 = __importDefault(require("./icons/list.svg"));
var loading_svg_1 = __importDefault(require("./icons/loading.svg"));
var listLargeThumbnail_svg_1 = __importDefault(require("./icons/listLargeThumbnail.svg"));
var listText_svg_1 = __importDefault(require("./icons/listText.svg"));
var listWithThumbnail_svg_1 = __importDefault(require("./icons/listWithThumbnail.svg"));
var location_svg_1 = __importDefault(require("./icons/location.svg"));
var lock_svg_1 = __importDefault(require("./icons/lock.svg"));
var lockUnlocked_svg_1 = __importDefault(require("./icons/lockUnlocked.svg"));
var more_svg_1 = __importDefault(require("./icons/more.svg"));
var music_svg_1 = __importDefault(require("./icons/music.svg"));
var money_svg_1 = __importDefault(require("./icons/money.svg"));
var menu_svg_1 = __importDefault(require("./icons/menu.svg"));
var pin_svg_1 = __importDefault(require("./icons/pin.svg"));
var placeholder_svg_1 = __importDefault(require("./icons/placeholder.svg"));
var presentation_svg_1 = __importDefault(require("./icons/presentation.svg"));
var previewOff_svg_1 = __importDefault(require("./icons/previewOff.svg"));
var previewOn_svg_1 = __importDefault(require("./icons/previewOn.svg"));
var projects_svg_1 = __importDefault(require("./icons/projects.svg"));
var pulse_svg_1 = __importDefault(require("./icons/pulse.svg"));
var refresh_svg_1 = __importDefault(require("./icons/refresh.svg"));
var report_svg_1 = __importDefault(require("./icons/report.svg"));
var remove_svg_1 = __importDefault(require("./icons/remove.svg"));
var safety_svg_1 = __importDefault(require("./icons/safety.svg"));
var search_svg_1 = __importDefault(require("./icons/search.svg"));
var send_svg_1 = __importDefault(require("./icons/send.svg"));
var settings_svg_1 = __importDefault(require("./icons/settings.svg"));
var share_svg_1 = __importDefault(require("./icons/share.svg"));
var sign_svg_1 = __importDefault(require("./icons/sign.svg"));
var spam_svg_1 = __importDefault(require("./icons/spam.svg"));
var speedometer_svg_1 = __importDefault(require("./icons/speedometer.svg"));
var star_svg_1 = __importDefault(require("./icons/star.svg"));
var statusNegative_svg_1 = __importDefault(require("./icons/statusNegative.svg"));
var statusPositive_svg_1 = __importDefault(require("./icons/statusPositive.svg"));
var statusPositiveNoBorder_svg_1 = __importDefault(require("./icons/statusPositiveNoBorder.svg"));
var statusNegativeNoBorder_svg_1 = __importDefault(require("./icons/statusNegativeNoBorder.svg"));
var stickers_svg_1 = __importDefault(require("./icons/stickers.svg"));
var suitcase_svg_1 = __importDefault(require("./icons/suitcase.svg"));
var switch_svg_1 = __importDefault(require("./icons/switch.svg"));
var tag_svg_1 = __importDefault(require("./icons/tag.svg"));
var teamMembers_svg_1 = __importDefault(require("./icons/teamMembers.svg"));
var teamPresetsCollaborationTool_svg_1 = __importDefault(require("./icons/teamPresetsCollaborationTool.svg"));
var teamPresetsCustomTeam_svg_1 = __importDefault(require("./icons/teamPresetsCustomTeam.svg"));
var teamPresetsMarketingWebsite_svg_1 = __importDefault(require("./icons/teamPresetsMarketingWebsite.svg"));
var teamPresetsMobileApp_svg_1 = __importDefault(require("./icons/teamPresetsMobileApp.svg"));
var teamPresetsPrototypingTool_svg_1 = __importDefault(require("./icons/teamPresetsPrototypingTool.svg"));
var teamPresetsWebPlatform_svg_1 = __importDefault(require("./icons/teamPresetsWebPlatform.svg"));
var teamPulse_svg_1 = __importDefault(require("./icons/teamPulse.svg"));
var teamSign_svg_1 = __importDefault(require("./icons/teamSign.svg"));
var undo_svg_1 = __importDefault(require("./icons/undo.svg"));
var upload_svg_1 = __importDefault(require("./icons/upload.svg"));
var user_svg_1 = __importDefault(require("./icons/user.svg"));
var video_svg_1 = __importDefault(require("./icons/video.svg"));
exports.iconMap = {
    ai: ai_svg_1.default,
    archive: archive_svg_1.default,
    attachedFile: attachedFile_svg_1.default,
    arrowForward: arrowForward_svg_1.default,
    arrowBack: arrowBack_svg_1.default,
    arrowUp: arrowUp_svg_1.default,
    arrowOpen: arrowOpen_svg_1.default,
    arrowClose: arrowClose_svg_1.default,
    arrowDown: arrowDown_svg_1.default,
    badge: badge_svg_1.default,
    block: block_svg_1.default,
    calendarEmpty: calendarEmpty_svg_1.default,
    calendarFull: calendarFull_svg_1.default,
    card: card_svg_1.default,
    cardAdd: cardAdd_svg_1.default,
    clock: clock_svg_1.default,
    code: code_svg_1.default,
    comment: comment_svg_1.default,
    copy: copy_svg_1.default,
    dashboard: dashboard_svg_1.default,
    delete: delete_svg_1.default,
    details: details_svg_1.default,
    download: download_svg_1.default,
    drafts: drafts_svg_1.default,
    edit: edit_svg_1.default,
    experienceAward: experienceAward_svg_1.default,
    experienceEducation: experienceEducation_svg_1.default,
    faq: faq_svg_1.default,
    favoriteAdd: favoriteAdd_svg_1.default,
    favoriteRemove: favoriteRemove_svg_1.default,
    filter: filter_svg_1.default,
    fingerprint: fingerprint_svg_1.default,
    graph: graph_svg_1.default,
    heart: heart_svg_1.default,
    image: image_svg_1.default,
    inbox: inbox_svg_1.default,
    key: key_svg_1.default,
    link: link_svg_1.default,
    list: list_svg_1.default,
    listLargeThumbnail: listLargeThumbnail_svg_1.default,
    listText: listText_svg_1.default,
    listWithThumbnail: listWithThumbnail_svg_1.default,
    location: location_svg_1.default,
    loading: loading_svg_1.default,
    lock: lock_svg_1.default,
    lockUnlocked: lockUnlocked_svg_1.default,
    money: money_svg_1.default,
    more: more_svg_1.default,
    music: music_svg_1.default,
    menu: menu_svg_1.default,
    pin: pin_svg_1.default,
    placeholder: placeholder_svg_1.default,
    presentation: presentation_svg_1.default,
    previewOff: previewOff_svg_1.default,
    previewOn: previewOn_svg_1.default,
    projects: projects_svg_1.default,
    pulse: pulse_svg_1.default,
    refresh: refresh_svg_1.default,
    remove: remove_svg_1.default,
    report: report_svg_1.default,
    safety: safety_svg_1.default,
    search: search_svg_1.default,
    send: send_svg_1.default,
    settings: settings_svg_1.default,
    share: share_svg_1.default,
    sign: sign_svg_1.default,
    spam: spam_svg_1.default,
    speedometer: speedometer_svg_1.default,
    star: star_svg_1.default,
    statusNegative: statusNegative_svg_1.default,
    statusNegativeNoBorder: statusNegativeNoBorder_svg_1.default,
    statusPositive: statusPositive_svg_1.default,
    statusPositiveNoBorder: statusPositiveNoBorder_svg_1.default,
    stickers: stickers_svg_1.default,
    suitcase: suitcase_svg_1.default,
    switch: switch_svg_1.default,
    tag: tag_svg_1.default,
    teamMembers: teamMembers_svg_1.default,
    teamPresetsCollaborationTool: teamPresetsCollaborationTool_svg_1.default,
    teamPresetsCustomTeam: teamPresetsCustomTeam_svg_1.default,
    teamPresetsMarketingWebsite: teamPresetsMarketingWebsite_svg_1.default,
    teamPresetsMobileApp: teamPresetsMobileApp_svg_1.default,
    teamPresetsPrototypingTool: teamPresetsPrototypingTool_svg_1.default,
    teamPresetsWebPlatform: teamPresetsWebPlatform_svg_1.default,
    teamPulse: teamPulse_svg_1.default,
    teamSign: teamSign_svg_1.default,
    undo: undo_svg_1.default,
    upload: upload_svg_1.default,
    user: user_svg_1.default,
    video: video_svg_1.default,
};
exports.sizeMap = {
    lg: 24,
    md: 16,
    sm: 12,
};
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    icon: {
        height: function (props) { return exports.sizeMap[props.size || 'lg']; },
        '& svg': {
            width: function (props) { return exports.sizeMap[props.size || 'lg']; },
            height: function (props) { return exports.sizeMap[props.size || 'lg']; },
            margin: function (props) {
                return "".concat(theme.margins[props.margin || 'none'], "px");
            },
            cursor: function (props) { return (props.onClick ? 'pointer' : 'default'); },
        },
    },
}); });
var Icon = function (props) {
    var theme = (0, react_jss_1.useTheme)();
    var styles = useStyles(__assign(__assign({}, props), { theme: theme }));
    var name = props.name, size = props.size, margin = props.margin, color = props.color, className = props.className, style = props.style, onClick = props.onClick, rest = __rest(props, ["name", "size", "margin", "color", "className", "style", "onClick"]);
    var themeColor = (0, react_1.useMemo)(function () {
        return color
            ? (0, theme_1.getThemeColorFromAlias)(color, theme.colors)
            : theme.colors.Grey[800];
    }, [color, theme.colors]);
    return (react_1.default.createElement("span", { onClick: onClick },
        react_1.default.createElement(react_svg_1.ReactSVG, __assign({ src: exports.iconMap[name], className: (0, classnames_1.default)(styles.icon, className), wrapper: 'span', style: __assign({ color: themeColor }, style) }, rest))));
};
exports.default = Icon;
//# sourceMappingURL=index.js.map